import React from "react";
import "./App.css";

import Dashboard from "./components/Dashboard";

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: null
    };
  }

  componentDidMount() {
    fetch(
      "https://kerckhoff.dailybruin.com/api/packages/flatpages/interactive.2020.covid-19/",
      {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(results => results.json())
      .then(results => this.setState({ query: results }));
  }

  render() {
    const { query } = this.state;
    if (!query) return <div></div>;
    const data = query.data["site.aml"];

    return (
      <div>
        <Dashboard info={data}></Dashboard>
      </div>
    );
  }
}
